class FormActions {
  static SYNC_FORM = "SYNC_FORM";

  static RESET_FORM_START = "RESET_FORM_START";
  static RESET_FORM_COMPLETE = "RESET_FORM_COMPLETE";

  static SAVE_IN_BROWSER = "SAVE_IN_BROWSER";
  static FETCHED_FROM_BROWSER = "FETCHED_FROM_BROWSER";

  static LOAD_FROM_BROWSER_START = "LOAD_FROM_BROWSER_START";
  static LOAD_FROM_BROWSER_COMPLETE = "LOAD_FROM_BROWSER_COMPLETE";

  static UPLOAD_FILE_START = "UPLOAD_FILE_START";
  static UPLOAD_FILE_INITIATED = "UPLOAD_FILE_INITIATED";
  static UPLOAD_FILE_COMPLETE = "UPLOAD_FILE_COMPLETE";

  static SET_FILE_NAME = "SET_FILE_NAME";

  static syncForm = (form, isValid) => {
    return {
      type: this.SYNC_FORM,
      payload: { form, isValid },
    };
  };

  static resetFormStart = () => {
    return {
      type: this.RESET_FORM_START,
    };
  };
  static resetFormComplete = () => {
    return {
      type: this.RESET_FORM_COMPLETE,
    };
  };

  static saveinBrowser = () => {
    return {
      type: this.SAVE_IN_BROWSER,
    };
  };
  static fetchedFromBrowser = () => {
    return {
      type: this.FETCHED_FROM_BROWSER,
    };
  };

  static loadFromBrowserStart = () => {
    return {
      type: this.LOAD_FROM_BROWSER_START,
    };
  };
  static loadFromBrowserComplete = () => {
    return {
      type: this.LOAD_FROM_BROWSER_COMPLETE,
    };
  };

  static uploadFileStart = (formValues) => {
    return {
      type: this.UPLOAD_FILE_START,
      payload: { formValues },
    };
  };
  static uploadFileInitiated = () => {
    return {
      type: this.UPLOAD_FILE_INITIATED,
    };
  };
  static uploadFileComplete = () => {
    return {
      type: this.UPLOAD_FILE_COMPLETE,
    };
  };

  static setFileName = (name) => {
    return {
      type: this.SET_FILE_NAME,
      payload: { name },
    };
  };

  /*===========
    PUBLISH XML
    =============*/
  static PUBLISH_XML = "PUBLISH_XML";
  static PUBLISH_XML_SUCCESS = "PUBLISH_XML_SUCCESS";
  static PUBLISH_XML_FAILURE = "PUBLISH_XML_FAILURE";

  static publishXML = () => {
    return {
      type: this.PUBLISH_XML,
    };
  };
  static publishXMLSuccess = (accessURL) => {
    return {
      type: this.PUBLISH_XML_SUCCESS,
      payload: {
        accessURL,
      },
    };
  };
  static publishXMLFailure = (errorMessage) => {
    return {
      type: this.PUBLISH_XML_FAILURE,
      payload: { errorMessage },
    };
  };

  /*===========
    SAVE PODCAST
    =============*/
  static SAVE_PODCAST = "SAVE_PODCAST";
  static SAVE_PODCAST_SUCCESS = "SAVE_PODCAST_SUCCESS";
  static SAVE_PODCAST_FAILURE = "SAVE_PODCAST_FAILURE";

  static savePodcast = () => {
    return {
      type: this.SAVE_PODCAST,
    };
  };
  static savePodcastSuccess = () => {
    return {
      type: this.SAVE_PODCAST_SUCCESS,
    };
  };
  static savePodcastFailure = (errorMessage) => {
    return {
      type: this.SAVE_PODCAST_FAILURE,
      payload: { errorMessage },
    };
  };

  /*===========
    GET MY PODCAST
    =============*/
  static GET_MY_PODCAST = "GET_MY_PODCAST";
  static GET_MY_PODCAST_SUCCESS = "GET_MY_PODCAST_SUCCESS";
  static GET_MY_PODCAST_FAILURE = "GET_MY_PODCAST_FAILURE";

  static getMyPodcast = () => {
    return {
      type: this.GET_MY_PODCAST,
    };
  };
  static getMyPodcastSuccess = () => {
    return {
      type: this.GET_MY_PODCAST_SUCCESS,
    };
  };
  static getMyPodcastFailure = (errorMessage) => {
    return {
      type: this.GET_MY_PODCAST_FAILURE,
      payload: { errorMessage },
    };
  };
}

export default FormActions;
